import React from 'react';
import type { ParserRule, ReactOutputRule } from 'simple-markdown';

/**
 * A `SimpleMarkdown` `email` rule to render email addresses as plain text
 * This rule has higher priority than link rules to prevent emails from being converted to URLs
 * @returns A `SimpleMarkdown` `email` rule
 */
export const buildEmail = () => {
  return {
    order: -1, // Higher priority than link rule (order: 0)
    match: (matchSrc) => {
      return /^([\w.+-]+@[\w.-]+\.[a-z]{2,6})/.exec(matchSrc);
    },
    parse: (capture) => {
      return {
        content: capture[1],
      };
    },
    react: (node, output, state) => {
      return (
        <span
          key={state.key}
          style={{ whiteSpace: 'nowrap' }}
          data-testid={`markdownCompiler-email-${state.key}`}
        >
          {node.content}
        </span>
      );
    },
  } as ParserRule & ReactOutputRule;
};
